import { FollowButtonDisplay, FollowButtonOutline, FollowButtonSize } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { articleTopicsContent$key } from "~/queries/__generated__/articleTopicsContent.graphql";

import {
  ArticleTopicsContainer,
  Item,
  MainItem,
  StyledEntityFollowButton,
  StyledTopicLink,
  TopicSeparator,
} from "./styles";

export type Props = {
  reference: articleTopicsContent$key;
};

export const ArticleTopics: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const { topics } = useFragment(
    graphql`
      fragment articleTopicsContent on Content {
        topics {
          ...topicLinkTopic
          ...entityFollowButtonBase
          entityId
        }
      }
    `,
    reference_,
  );
  if (!topics || topics.length === 0) return null;
  const [mainTopic, ...otherTopics] = topics;

  const renderSeparator = (index: number) => {
    if (index === otherTopics.length - 1) return null;
    return <TopicSeparator>|</TopicSeparator>;
  };
  return (
    <ArticleTopicsContainer>
      {mainTopic && (
        <MainItem>
          <StyledTopicLink reference={mainTopic} />
          <StyledEntityFollowButton
            display={FollowButtonDisplay.Icon}
            outline={FollowButtonOutline.Plain}
            reference={mainTopic}
            size={FollowButtonSize.Compact}
            source="Article_topic_footer"
          />
        </MainItem>
      )}

      {otherTopics.map(
        (topic, index) =>
          topic && (
            <Item key={topic.entityId}>
              <StyledTopicLink reference={topic} />
              <StyledEntityFollowButton
                display={FollowButtonDisplay.Icon}
                outline={FollowButtonOutline.Plain}
                reference={topic}
                size={FollowButtonSize.Compact}
                source="Article_topic_footer"
              />
              {renderSeparator(index)}
            </Item>
          ),
      )}
    </ArticleTopicsContainer>
  );
};

ArticleTopics.displayName = "ArticleTopics";
